import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaRegNewspaper } from "react-icons/fa";
import { RiContactsLine } from "react-icons/ri";
import { MdDashboard, MdOutlineWork } from "react-icons/md";
import "../App.css";

const menus = [
  {
    label: "Dashboard",
    to: "/dashboard",
    icon: <MdDashboard />,
  },
  {
    label: "News",
    to: "/news-admin",
    icon: <FaRegNewspaper />,
  },
  {
    label: "Job",
    to: "/job-admin",
    icon: <MdOutlineWork />,
  },
  {
    label: "Contact",
    to: "/contact-admin",
    icon: <RiContactsLine />,
  },
];

const NavBar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <aside className={`admin-sidebar ${isCollapsed ? "is-collapsed" : ""}`}>
      <div className="admin-sidebar-inner">
        <div className="admin-sidebar-brand">
          <button
            type="button"
            onClick={() => setIsCollapsed((prev) => !prev)}
            className="admin-sidebar-toggle"
            aria-label="Toggle admin menu"
          >
            <FaBars />
          </button>
          {!isCollapsed && (
            <div className="admin-brand-copy">
              <strong>BAS</strong>
              <span>Admin Panel</span>
            </div>
          )}
        </div>

        <nav className="admin-sidebar-nav" aria-label="Admin navigation">
          {menus.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/dashboard"}
              className={({ isActive }) =>
                `admin-sidebar-link ${isActive ? "is-active" : ""}`
              }
              title={isCollapsed ? item.label : undefined}
            >
              <span className="admin-sidebar-link-icon">{item.icon}</span>
              {!isCollapsed && (
                <span className="admin-sidebar-link-label">{item.label}</span>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </aside>
  );
};

export default NavBar;
